import { useMarkerSearch } from './useMarkerSearch';
import { usePropertySearchRequest } from './usePropertySearchRequest';

export function useFilteredMarkers() {
  const request = usePropertySearchRequest('markers');
  return useMarkerSearch(request);
}
